const LOGIN = '/api/engauge/login';
const COURSES = '/api/v1/engauge/courses';
const EBOOKS = '/api/v1/engauge/ebooks';
const USER_EBOOKS = '/api/v1/engauge/selections';
const MULTIPLE_CHOICE_ANSWERS = '/api/v1/engauge/multiple-choice-answers';
const SHORT_ANSWERS = '/api/v1/engauge/short-answers';
const HISTORIES = '/api/v1/engauge/histories';
const USERS = '/api/v1/engauge/users';
const USER_COURSES = '/api/v1/engauge/user-courses';
const USER_TAGS = '/api/v1/engauge/user-tags';
const TAGS = '/api/v1/engauge/tags';
const NOTIFICATIONS = '/api/v1/engauge/notifications';

export {
  MULTIPLE_CHOICE_ANSWERS,
  SHORT_ANSWERS,
  COURSES,
  EBOOKS,
  HISTORIES,
  LOGIN,
  TAGS,
  USERS,
  USER_COURSES,
  USER_EBOOKS,
  USER_TAGS,
  NOTIFICATIONS
};
